var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _mask, _g, _path18, _path19, _path20, _path21, _path22, _path23, _mask2, _g2, _path24, _mask3, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNullNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 191,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.27 118.725c-.853-6.589-6.331-11.678-12.979-11.678-1.396 0-2.74.23-4.002.645-.663-11.048-9.59-19.799-20.51-19.799-1.661 0-3.274.207-4.821.59C48.279 82.77 41.972 79 34.806 79c-11.352 0-20.554 9.455-20.554 21.118 0 1.71.203 3.372.577 4.964a12.91 12.91 0 00-1.453-.087c-7.238 0-13.106 6.029-13.106 13.466 0 .089.01.175.013.264h93.986z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.27 121.725c-.853-6.589-6.331-11.678-12.979-11.678-1.396 0-2.74.23-4.002.645-.663-11.048-9.59-19.799-20.51-19.799-1.661 0-3.274.207-4.821.59C282.279 85.77 275.973 82 268.806 82c-11.352 0-20.554 9.455-20.554 21.118 0 1.71.203 3.372.577 4.964a12.898 12.898 0 00-1.453-.087c-7.238 0-13.106 6.029-13.106 13.466 0 .089.011.175.013.264h93.987z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.358 96.53c-1.171-8.823-8.694-15.634-17.823-15.634-1.917 0-3.762.306-5.496.862-.911-14.79-13.17-26.504-28.166-26.504-2.281 0-4.496.277-6.621.789-5.051-7.648-13.712-12.695-23.554-12.695-15.589 0-28.227 12.657-28.227 28.27 0 2.29.279 4.515.793 6.647a18.139 18.139 0 00-1.995-.117c-9.94 0-17.999 8.071-17.999 18.028 0 .119.015.234.018.353h129.07z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.688 48.043l-8.004-4.622s-4.568 4.573-1.254 6.43c3.313 1.858 5.68 3.28 7.676 4.433-1.514-3.493 1.582-6.241 1.582-6.241z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.206 63.08l15.503-2.733s6.116 18.314-.28 19.293c-6.397.978-11.003 1.94-14.869 2.621 3.925-7.735-.354-19.18-.354-19.18z",
    fill: "#EA4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.238 51.316s1.002 11.358.33 11.427c-.673.068-11.501 0-15.682 1.3 0 0-.616-9.1-.616-11.77 0 0 6.921-1.368 15.968-.957z",
    fill: "#FCC934"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.094 79.784l6.812 18.717s-21.477 11.646-24.102 3.89-4.835-13.284-6.534-17.95c10.502 3.19 23.824-4.657 23.824-4.657z",
    fill: "#34A853"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.664 124l-46.112-14.76-24.283 19.644 46.113 14.76L139.664 124z",
    fill: "#DADCE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.664 118l-46.112-14.76-24.283 19.644 46.113 14.76L139.664 118z",
    fill: "#E8EAED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.664 112L93.552 97.24l-24.283 19.644 46.113 14.76L139.664 112z",
    fill: "#F1F3F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.664 164l-46.112-14.76-24.283 19.644 46.113 14.76L258.664 164z",
    fill: "#DADCE0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M258.664 158l-46.112-14.76-24.283 19.644 46.113 14.76L258.664 158z",
    fill: "#E8EAED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M258.664 152l-46.112-14.76-24.283 19.644 46.113 14.76L258.664 152z",
    fill: "#F1F3F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200.664 142l-46.112-14.76-24.283 19.644 46.113 14.76L200.664 142z",
    fill: "#DADCE0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.664 136l-46.112-14.76-24.283 19.644 46.113 14.76L200.664 136z",
    fill: "#E8EAED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.664 130l-46.112-14.76-24.283 19.644 46.113 14.76L200.664 130z",
    fill: "#F1F3F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.924 127.369l39.484-1.499s6.38 23.305-9.841 23.739c-16.221.434-28.023 1.064-37.868 1.437 13.336-9.058 8.225-23.677 8.225-23.677z",
    fill: "#81C995"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 125,
    width: 50,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.924 127.369l39.484-1.499s6.38 23.305-9.841 23.739c-16.221.434-28.023 1.064-37.868 1.437 13.336-9.058 8.225-23.677 8.225-23.677z",
    fill: "#A8DAB5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.455 131.753l-4.665.164-.06 2.022-3.888.136.08-2.696-3.888.136-.04 1.348-1.518-1.213.043-1.429-.778.027-.042 1.429-1.593 1.322-.121 4.044-2.11.109.037-1.247-2.269-2.042-2.396 2.205-.096 3.213c-.047 1.565-3.945 2.047-3.888.136l.099-3.314-2.888.137-.041 1.348-3.332.081.201-6.741-8.776.272-.502 16.851 48.21-1.687.422-14.154-6.221.217.02-.674z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.841 143.348l-2.325.076.038-1.355-3.876.127-.076 2.711-3.101.102.074-2.609s-.118-2.13-2.265-2.059c-2.147.07-2.385 2.211-2.385 2.211l-.036 1.255-2.325.076.038-1.356-4.651.153-.038 1.356-4.651.153.077-2.712-3.875.128.057-2.034-3.875.128-.019.677-6.201.204-.316 11.154 48.056-1.58.393-13.865-8.526.28-.192 6.779z",
    fill: "#137333"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.049 95.104L145.6 108.785s12.182 32.132 22.102 26.281c9.92-5.851 17.352-9.71 23.448-13.121-14.117-6.247-21.101-26.841-21.101-26.841z",
    fill: "#EA4335"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.658 122.358c-.138-.375-.386-.849-.529-1.214a10.548 10.548 0 01-.472-1.919 10.668 10.668 0 01-.074-2.121c.058-.735.191-1.463.397-2.172.265-.859.639-1.681 1.113-2.444.369-.576.791-1.114 1.262-1.609.431-.447.902-.855 1.406-1.218.465-.328.957-.616 1.471-.862.47-.214.956-.392 1.453-.531a9.69 9.69 0 011.389-.304l.082-.03c1.258-.053 2.292.846 3.471 3.026-5.017.714-10.014 4.384-11.158 8.181a4.282 4.282 0 00.173 3.251",
    fill: "#FAD2CF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.179 107.895c.357-.038.843-.077 1.205-.098a10.022 10.022 0 014.318.892c.689.306 1.342.688 1.946 1.14a9.781 9.781 0 011.911 1.929c.33.44.625.904.88 1.391-.945-1.82-3.457-2.762-6.801-2.261-1.179-2.179-2.215-3.087-3.471-3.026",
    fill: "#EE675C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.02 127.696a10.007 10.007 0 01-5.585-.79 10.068 10.068 0 01-1.946-1.14 9.753 9.753 0 01-1.911-1.929c-.33-.439-.625-.904-.88-1.391l-.036-.097a4.28 4.28 0 01-.174-3.25c1.144-3.797 6.143-7.457 11.156-8.18 3.395 6.959 2.504 16.216-.607 16.771",
    fill: "#F28B82"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.445 113.186c.144.391.412.895.564 1.283.217.624.375 1.266.472 1.919.095.703.12 1.413.074 2.12a10.83 10.83 0 01-.397 2.172c-.265.859-.639 1.68-1.113 2.443-.368.575-.79 1.114-1.261 1.609-.432.446-.902.854-1.405 1.217-.466.327-.958.616-1.471.861a9.91 9.91 0 01-1.453.532 9.846 9.846 0 01-1.388.304c3.397-.835 3.723-10.394.607-16.769 3.343-.5 5.855.441 6.8 2.261",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.033 74.325l.43.138c.565.178 1.395.436 2.457.753 2.123.635 5.174 1.508 8.89 2.46 7.329 1.88 17.246 4.07 27.716 5.359l-6.103 31.58-.074-.014-1.313-.243c-1.13-.21-2.744-.512-4.679-.879a1177.28 1177.28 0 01-14.144-2.764c-5.125-1.037-10.221-2.118-13.983-3.029-1.883-.455-3.423-.866-4.463-1.205-.524-.171-.902-.317-1.132-.436l-.054-.029c.045-.125.09-.277.137-.44.089-.312.194-.723.312-1.215.236-.985.529-2.31.857-3.857a796.507 796.507 0 002.231-11.028 2099.253 2099.253 0 002.915-15.15z",
    fill: "#A0C0F9",
    stroke: "#fff",
    strokeWidth: 0.8
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 73,
    width: 47,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.017 74.324l.431.137c.565.18 1.395.438 2.457.755 2.125.636 5.177 1.51 8.894 2.464 7.332 1.882 17.253 4.079 27.726 5.372l-6.086 31.564-.075-.013-1.313-.244c-1.131-.211-2.745-.514-4.681-.881-3.87-.736-9.022-1.731-14.148-2.771-5.128-1.04-10.225-2.124-13.989-3.036-1.884-.456-3.424-.867-4.465-1.207-.524-.171-.902-.318-1.132-.436l-.054-.03c.045-.125.09-.276.137-.44.088-.311.193-.722.31-1.213.237-.985.529-2.31.856-3.856.655-3.092 1.453-7.08 2.226-11.023a2089.744 2089.744 0 002.74-14.262l.166-.88z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.934 105.366a2.66 2.66 0 00-3.038-2.727 4.174 4.174 0 00-4.441-4.604 4.161 4.161 0 00-3.122-2.43 4.182 4.182 0 00-4.859 4.426 2.667 2.667 0 00-3.356 2.126c-.003.017-.003.034-.006.052l18.822 3.157z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.637 101.422a2.66 2.66 0 00-3.038-2.726 4.175 4.175 0 00-4.44-4.605 4.163 4.163 0 00-3.123-2.43 4.182 4.182 0 00-4.859 4.426 2.667 2.667 0 00-3.356 2.125l-.006.053 18.822 3.157z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45 100.395a2.663 2.663 0 014.034-.627 4.18 4.18 0 016.237-1.436A4.168 4.168 0 0198.664 98a4.177 4.177 0 011.655 6.357 2.664 2.664 0 011.651 3.61c-.007.017-.016.031-.023.047l-17.497-7.619z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M93.658 91.327c2.452.727 5.033-.68 5.765-3.14.733-2.46-.66-5.043-3.112-5.77-2.452-.726-5.033.68-5.766 3.14-.732 2.46.661 5.044 3.113 5.77z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.627 110.796l16.833-11.97 11.145 17.349-27.978-5.379z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.771 109.346l20.088-17.65 13.745 25.956-33.833-8.306z",
    fill: "#6397F6"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.033 74.325l.43.138c.565.178 1.395.436 2.457.753 2.123.635 5.174 1.508 8.89 2.46 7.329 1.88 17.246 4.07 27.716 5.359l-6.103 31.58-.074-.014-1.313-.243c-1.13-.21-2.744-.512-4.679-.879a1177.28 1177.28 0 01-14.144-2.764c-5.125-1.037-10.221-2.118-13.983-3.029-1.883-.455-3.423-.866-4.463-1.205-.524-.171-.902-.317-1.132-.436l-.054-.029c.045-.125.09-.277.137-.44.089-.312.194-.723.312-1.215.236-.985.529-2.31.857-3.857a796.507 796.507 0 002.231-11.028 2099.253 2099.253 0 002.915-15.15z",
    stroke: "#fff",
    strokeWidth: 0.8
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 73,
    width: 47,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.033 74.325l.43.138c.565.178 1.395.436 2.457.753 2.123.635 5.174 1.508 8.89 2.46 7.329 1.88 17.246 4.07 27.716 5.359l-6.103 31.58-.074-.014-1.313-.243c-1.13-.21-2.744-.512-4.679-.879a1177.28 1177.28 0 01-14.144-2.764c-5.125-1.037-10.221-2.118-13.983-3.029-1.883-.455-3.423-.866-4.463-1.205-.524-.171-.902-.317-1.132-.436l-.054-.029c.045-.125.09-.277.137-.44.089-.312.194-.723.312-1.215.236-.985.529-2.31.857-3.857a796.507 796.507 0 002.231-11.028 2099.253 2099.253 0 002.915-15.15z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.902 81.433l-59.03-8.446-10.787 63.957 59.03 8.447 10.787-63.958zm-2.48 1.973l-10.02 59.412-54.836-7.847 10.02-59.412 54.836 7.847z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.217 108.976l8.579-54.481 54.398 8.444-8.578 54.481-54.399-8.444z",
    fill: "#8AB4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.01 95.126c.116-6.794-2.279-12.632-7.186-13.715-5.657-1.247-11.734 4.38-13.53 12.373 0 0-.34 2.492.773 4.347 1.57 1.868-2.342 3.591-3.693 4.466-1.812 1.172-1.297 6.469-1.297 6.469l21.836 4.816s1.21-5.251-.221-6.804c-1.047-1.136 1.349-3.649 2.148-5.721.798-2.071 1.152-5.194 1.17-6.23z",
    fill: "#185ABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.793 114.957c-2.112-2.587-6.336-7.25-14.803-9.121-8.466-1.87-13.712.398-16.374 2.233l31.177 6.888z",
    fill: "#D2E3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.841 98.995c-1.167-1.658 8.519 1.133 8.519 1.133-1.224-.27-2.356 7.034-2.356 7.034s.286 3.055-4.128 2.082c-4.415-.974-3.366-3.648-3.366-3.648s2.498-4.942 1.331-6.6z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.841 98.995c-1.167-1.658 8.519 1.133 8.519 1.133-1.224-.27-2.356 7.034-2.356 7.034s.286 3.055-4.128 2.082c0 0-.868-8.59-2.035-10.249z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.085 101.753c.403.23.836.4 1.297.502 1.162.256 2.355.045 3.479-.538v-.002.002l.207-.112c2.066-1.165 3.873-3.588 4.787-6.665 0 0-.74-1.944-2.578-2.794-1.837-.85-8.207-4.172-8.468-5.457 0 0 .008-.014-.01.014-.783 1.249-1.32 2.597-1.688 4.234-1.055 4.694.213 9.238 2.974 10.816l.163.086-.163-.086z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.27,
    y1: 79,
    x2: 0.27,
    y2: 118.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 234.27,
    y1: 82,
    x2: 234.27,
    y2: 121.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 107.27,
    y1: 43.348,
    x2: 107.27,
    y2: 96.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 110.228,
    y1: 104.577,
    x2: 110.879,
    y2: 100.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0C0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82ABF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 84.931,
    y1: 100.633,
    x2: 85.582,
    y2: 96.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0C0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82ABF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 88.825,
    y1: 102.3,
    x2: 90.396,
    y2: 98.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0C0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82ABF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 95.877,
    y1: 91.985,
    x2: 97.198,
    y2: 87.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0C0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82ABF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 97.384,
    y1: 113.901,
    x2: 106.052,
    y2: 111.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2884FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6397F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullNotes);
export default __webpack_public_path__ + "static/media/nullNotes.c68b4968679d46b419761678e4b7d443.svg";
export { ForwardRef as ReactComponent };